define('apps/course-intro/views/main-layout',[
    'apps/course-intro/templates/main-layout',
    'apps/course-intro/views/intro'
], function (template, ModuleSelectionView) {
    "use strict";

    return Mn.LayoutView.extend({
        "el": "#course-intro",

        "regions": {
            "main": ".region-main"
        },

        "template": template,

        "onRender": function(){
            this.showChildView('main', new ModuleSelectionView({
                "model": this.model
            }));
        }
    });
});

